import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const About = () => {
  const teamMembers = [
    {
      name: "Col Raja Somusundaram (Retd)",
      role: "Founder & CMD",
      image: "/images/raja.jpg",
      bio: "A passionate golf enthusiast and accomplished player who, after years on the green, founded Golf4i International to address the unique challenges faced by golfers and drive innovation in the golfing industry.",
      social: {
        linkedin: "#",
        twitter: "#"
      }
    },
    {
      name: "Lt Col (Mrs) Arita Raja (Retd)",
      role: "Director",
      image: "/images/arita.jpg",
      bio: "Driving innovation in the global golf industry and delivering expert strategy in golfing business development, bringing strategic vision and operational excellence to Golf 4i International's mission of revolutionizing the golfing experience.",
      social: {
        linkedin: "#",
        twitter: "#"
      }
    },
    {
      name: "Simulator Operator - Kolkata",
      role: "Technical Staff",
      image: "/images/operator.jpg",
      bio: "An expert in golf simulator technology and software integration, leading advancements at Golf 4i International to create immersive, data-driven golfing solutions for players and businesses worldwide.",
      social: {
        linkedin: "#",
        twitter: "#"
      }
    },
    {
      name: "Mr. Mahesh Ahirwar",
      role: "Accountant",
      image: "/images/mahesh.jpg",
      bio: "Manages financial records and ensures all transactions are accurately recorded. Prepares reports and statements to support business planning and decisions. Ensures compliance with financial regulations and helps maintain financial health.",
      social: {
        linkedin: "#",
        twitter: "#"
      }
    }
  ];

  const milestones = [
    { year: "2022", event: "Company Founded", detail: "Golf4International Private Limited established" },
    { year: "2023", event: "First Facility Launch", detail: "Delhi headquarters and training center opened" },
    { year: "2024", event: "Technology Integration", detail: "Advanced simulator systems implemented" },
    { year: "2025", event: "National Expansion", detail: "Planned expansion to 5 major cities" }
  ];

  const stats = [
    { value: "1000+", label: "Students Trained", icon: "👨‍🎓" },
    { value: "15+", label: "Certified Coaches", icon: "🏌️" },
    { value: "24/7", label: "Simulator Access", icon: "🖥️" },
    { value: "4", label: "Team Members", icon: "👥" },
    { value: "98%", label: "Satisfaction Rate", icon: "⭐" },
    { value: "5", label: "Cities Planned", icon: "🏙️" }
  ];

  return (
    <>
      {/* Hero Section with Animation */}
      <section style={{
        height: '70vh',
        background: 'linear-gradient(rgba(31, 61, 43, 0.85), rgba(31, 61, 43, 0.95)), url(https://images.unsplash.com/photo-1535131749006-b7f58c99034b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80) center/cover no-repeat fixed',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Animated Background Elements */}
        <div className="position-absolute top-0 start-0 w-100 h-100" style={{
          background: 'radial-gradient(circle at 30% 30%, rgba(181, 154, 90, 0.15) 0%, transparent 50%)',
          animation: 'pulse 4s ease-in-out infinite'
        }}></div>

        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center text-white">
              <div className="animate-fade-in-up">
                <h1 className="display-3 fw-bold mb-4" style={{ color: '#B59A5A' }}>About Golf4International</h1>
                <p className="lead mb-4" style={{ fontSize: '1.5rem', opacity: 0.9 }}>
                  Transforming India's golf landscape through innovation, accessibility, and excellence since 2022
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <a href="#team" className="btn-gold-filled btn-lg px-5 py-3">Meet Our Team</a>
                  <a href="#journey" className="btn-gold btn-lg px-5 py-3">Our Journey</a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Story Section */}
      <section className="section-padding">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={6} className="mb-5 mb-lg-0">
              <div className="animate-fade-in-up">
                <h2 className="display-5 fw-bold mb-4">Our Story</h2>
                <p style={{ color: '#666', fontSize: '1.1rem' }} className="mb-4">
                  Founded in 2022, Golf4International was born from a vision to democratize golf in India.
                  We recognized that traditional golf models created unnecessary barriers for enthusiasts,
                  making the sport seem exclusive and inaccessible.
                </p>
                <p style={{ color: '#666' }} className="mb-4">
                  Our mission is clear: to make golf accessible and within reach of all enthusiasts,
                  demystifying and compressing the game into a shorter, affordable version while
                  maintaining the highest standards of quality and professionalism.
                </p>
              </div>
            </Col>

            <Col lg={6}>
              <div className="animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
                <div style={{
                  height: '400px',
                  background: 'url(https://plus.unsplash.com/premium_photo-1725408156943-6fb39d08458d?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Z29sZiUyMGdyZWVufGVufDB8fDB8fHww) center/cover no-repeat',
                  borderRadius: '15px',
                  boxShadow: '0 20px 40px rgba(31, 61, 43, 0.15)',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                  <div className="position-absolute top-4 start-4">
                    <div className="bg-white rounded-pill px-3 py-2 shadow-sm">
                      <span className="small fw-bold" style={{ color: 'var(--primary-green)' }}>
                        🏆 Since 2022
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* Stats Section */}
          <Row className="mt-5">
            {stats.map((stat, index) => (
              <Col md={4} lg={2} className="text-center mb-4" key={index}>
                <div className="animate-fade-in-up" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div className="p-3">
                    <div style={{
                      width: '70px',
                      height: '70px',
                      backgroundColor: 'var(--soft-sage)',
                      borderRadius: '50%',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.8rem',
                      marginBottom: '1rem'
                    }}>
                      {stat.icon}
                    </div>
                    <h3 className="h2 mb-1" style={{ color: 'var(--muted-gold)' }}>{stat.value}</h3>
                    <p style={{ color: '#666' }} className="small fw-medium">{stat.label}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Mission & Vision Section */}
      <section className="section-padding bg-soft-sage">
        <Container>
          <Row className="g-5">
            <Col lg={6}>
              <div className="p-5 rounded h-100" style={{
                background: 'white',
                boxShadow: '0 10px 30px rgba(31, 61, 43, 0.1)',
                borderTop: '4px solid var(--muted-gold)'
              }}>
                <div className="d-flex align-items-center mb-4">
                  <div style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: 'var(--muted-gold)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px',
                    flexShrink: 0
                  }}>
                    <span className="h4 text-white mb-0">M</span>
                  </div>
                  <h2 className="h3 mb-0">Our Mission</h2>
                </div>
                <p style={{ color: '#666', fontSize: '1.1rem' }} className="mb-4">
                  To make Indian sportsmen aware of golf and make it accessible for all enthusiasts,
                  demystifying and compressing the game into a shorter, affordable version that
                  maintains the essence and joy of the sport while upholding international standards.
                </p>
                <div className="mt-4">
                  <h4 className="h5 mb-3" style={{ color: 'var(--muted-gold)' }}>Key Focus Areas:</h4>
                  <ul style={{ color: '#666' }}>
                    <li className="mb-2">Democratizing access to golf facilities</li>
                    <li className="mb-2">Affordable membership models</li>
                    <li className="mb-2">Quality coaching at every level</li>
                    <li>Technology-driven training solutions</li>
                  </ul>
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div className="p-5 rounded h-100" style={{
                background: 'white',
                boxShadow: '0 10px 30px rgba(31, 61, 43, 0.1)',
                borderTop: '4px solid var(--primary-green)'
              }}>
                <div className="d-flex align-items-center mb-4">
                  <div style={{
                    width: '50px',
                    height: '50px',
                    backgroundColor: 'var(--primary-green)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '15px',
                    flexShrink: 0
                  }}>
                    <span className="h4 text-white mb-0">V</span>
                  </div>
                  <h2 className="h3 mb-0">Our Vision</h2>
                </div>
                <p style={{ color: '#666', fontSize: '1.1rem' }} className="mb-4">
                  To nurture raw talent and produce world-class golfers in India through systematic
                  coaching, international-standard facilities, and a holistic development approach
                  that creates champions on and off the course.
                </p>
                <div className="mt-4">
                  <h4 className="h5 mb-3" style={{ color: 'var(--primary-green)' }}>Strategic Goals:</h4>
                  <ul style={{ color: '#666' }}>
                    <li className="mb-2">Develop 100+ professional golfers by 2030</li>
                    <li className="mb-2">Establish 20+ training centers across India</li>
                    <li className="mb-2">Create golf scholarships for underprivileged youth</li>
                    <li>Host international golf tournaments in India</li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Team Section - Updated with New Data */}
      <section id="team" className="section-padding">
        <Container>
          <Row className="mb-5">
            <Col lg={10} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-4">🤝 Meet Our Team</h2>
              <p style={{ color: '#666', fontSize: '1.1rem' }} className="mb-4">
                Dedicated professionals driving golfing excellence. Our team of golf professionals, instructors,
                and support staff is committed to providing elite coaching and creating a welcoming, high-performance golf environment.
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            {teamMembers.map((member, index) => (
              <Col lg={3} md={6} key={index}>
                <div className="animate-fade-in-up" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div className="team-card h-100" style={{
                    background: 'white',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
                  }}>
                    {/* Team Member Image */}
                    <div style={{
                      height: '250px',
                      background: `url(${member.image}) center/cover no-repeat`,
                      position: 'relative'
                    }}>
                      {/* Overlay Gradient */}
                      <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(to bottom, transparent 60%, rgba(31, 61, 43, 0.8) 100%)'
                      }}></div>

                      {/* Role Badge */}
                      <div className="position-absolute bottom-4 left-4">
                        <div className="bg-white rounded-pill px-3 py-1">
                          <span className="small fw-bold" style={{ color: 'var(--primary-green)' }}>
                            {member.role}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Team Member Info */}
                    <div className="p-4">
                      <h3 className="h5 mb-2" style={{ color: 'var(--primary-green)' }}>
                        {member.name}
                      </h3>

                      <p style={{ color: '#666', fontSize: '0.9rem' }} className="mb-3">
                        {member.bio}
                      </p>

                      {/* Social Links */}
                      <div className="d-flex justify-content-center gap-3 pt-3 border-top">
                        <a
                          href={member.social.linkedin}
                          className="text-decoration-none"
                          style={{ color: '#0077B5' }}
                          title="LinkedIn"
                        >
                          <i className="fab fa-linkedin fa-lg"></i>
                        </a>
                        <a
                          href={member.social.twitter}
                          className="text-decoration-none"
                          style={{ color: '#1DA1F2' }}
                          title="Twitter"
                        >
                          <i className="fab fa-twitter fa-lg"></i>
                        </a>
                      </div>
                    </div>

                    {/* Hover Effect */}
                    <style jsx>{`
                      .team-card:hover {
                        transform: translateY(-10px);
                        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
                      }
                      
                      .team-card:hover h3 {
                        color: var(--muted-gold) !important;
                        transition: color 0.3s ease;
                      }
                    `}</style>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Team Description */}
          <Row className="mt-5">
            <Col lg={10} className="mx-auto text-center">
              <div className="p-5 bg-soft-sage rounded">
                <h3 className="h4 mb-3">🌐 The People Behind the Precision</h3>
                <p style={{ color: '#666' }} className="mb-0">
                  Golf4i is backed by a dynamic team of golf pros, engineers, product designers, support technicians,
                  and strategic advisors. We blend sports knowledge with tech innovation to build the future of golf in India.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Journey Timeline */}
      <section id="journey" className="section-padding bg-soft-sage">
        <Container>
          <Row className="mb-5">
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-4">Our Journey</h2>
              <p style={{ color: '#666' }}>
                Key milestones in our mission to transform golf accessibility in India.
              </p>
            </Col>
          </Row>

          <div className="position-relative">
            {/* Timeline line */}
            <div style={{
              position: 'absolute',
              left: '50%',
              top: '0',
              bottom: '0',
              width: '3px',
              backgroundColor: 'var(--muted-gold)',
              transform: 'translateX(-50%)',
              zIndex: 0
            }}></div>

            {milestones.map((milestone, index) => (
              <div key={index} className={`d-flex align-items-center mb-5 position-relative ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                <div className="w-50">
                  <div className={`p-4 ${index % 2 === 0 ? 'pe-5 text-end' : 'ps-5'}`}>
                    <div className="bg-white rounded p-4 shadow-sm">
                      <h3 className="h4 mb-2" style={{ color: 'var(--muted-gold)' }}>{milestone.year}</h3>
                      <h4 className="h5 mb-2">{milestone.event}</h4>
                      <p style={{ color: '#666' }} className="mb-0">{milestone.detail}</p>
                    </div>
                  </div>
                </div>

                {/* Timeline dot */}
                <div style={{
                  width: '25px',
                  height: '25px',
                  backgroundColor: 'var(--muted-gold)',
                  borderRadius: '50%',
                  border: '5px solid white',
                  position: 'relative',
                  zIndex: 1,
                  boxShadow: '0 0 0 3px var(--muted-gold)'
                }}></div>

                <div className="w-50"></div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <div className="p-5 rounded" style={{
                background: 'linear-gradient(135deg, var(--primary-green) 0%, #2a4d3b 100%)',
                color: 'white'
              }}>
                <h3 className="h2 mb-3">Join Our Golf Revolution</h3>
                <p className="mb-4" style={{ opacity: 0.9 }}>
                  Be part of India's growing golf community. Whether you're a beginner or a seasoned player,
                  we have the perfect program for you.
                </p>
                <div className="d-flex flex-wrap justify-content-center gap-3">
                  <a href="/contact" className="btn-gold-filled" style={{ background: 'white', color: 'var(--primary-green)' }}>
                    Get in Touch
                  </a>
                  <a href="/services" className="btn-gold" style={{ borderColor: 'white', color: 'white' }}>
                    Explore Services
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Add CSS animations */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes pulse {
          0%, 100% {
            opacity: 0.1;
          }
          50% {
            opacity: 0.2;
          }
        }
        
        .animate-fade-in-up {
          animation: fadeInUp 0.6s ease-out forwards;
        }
        
        .team-card {
          position: relative;
        }
        
        .team-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, var(--muted-gold) 0%, var(--primary-green) 100%);
          border-radius: 15px 15px 0 0;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        
        .team-card:hover::before {
          opacity: 1;
        }
      `}</style>
    </>
  );
};

export default About;